<template>
    <v-table v-if="jobItemTasks" denisity="compact" class="small-table text-caption">
        <thead>
            <tr>
                <th :class="{'w-60':!showStockSelector, 'w-40':showStockSelector}">Product</th>
                <th class="text-right" :class="{'w-40':!showStockSelector, 'w-20':showStockSelector}">Quantity</th>
                <th v-if="showStockSelector" class="w-20 text-right">Picked Stock</th>
                <th v-if="showStockSelector" class="w-20 text-right">Stock → Strip</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="line in jobItemTasks" :key="line.id">
                <td>
                    {{ line.description }}
                </td>
                <td :class="{'full-select-quantity':line.quantity >= line.itemQuantity, 'part-select-quantity':line.quantity > 0}" class="no-select-quantity">
                    <v-text-field density="compact"
                                  reverse
                                  hide-details="auto"
                                  :disabled="line.itemQuantity == 0"
                                  @change="$emit('update:jobItemTasks', jobItemTasks);"
                                  v-model.number="line.quantity"></v-text-field>
                    <v-row>
                        <v-col cols="12"><small>ORDER QTY: <b>{{ line.itemQuantity }}</b></small></v-col>
                    </v-row>
                </td>
                <td v-if="showStockSelector" :class="{'full-select-quantity':line.pickedQuantity >= line.itemQuantity, 'part-select-quantity':line.pickedQuantity > 0}" class="no-select-quantity">
                    <v-text-field density="compact"
                                  reverse
                                  hide-details="auto"
                                  :disabled="line.quantity == 0"
                                  @change="$emit('update:jobItemTasks', jobItemTasks);"
                                  v-model.number="line.pickedQuantity"></v-text-field>
                    <v-row>
                        <v-col cols="12">
                            <v-tooltip v-if="line.length" :text="'Picked piece not '+line.length+'M'">
                                <template v-slot:activator="{ props }">
                                    <v-btn :disabled="!line.pickedQuantity || line.pickedQuantity == 0" class="my-1" @click="line.differentLength = !line.differentLength" :variant="line.differentLength ? 'flat' : 'outlined'" block color="primary" size="small" density="compact" v-bind="props">CHANGE LENGTH</v-btn>
                                </template>
                            </v-tooltip>
                            <small v-if="!line.length">No Length</small>
                            <v-text-field v-if="line.differentLength" density="compact"
                                          reverse
                                          label="Stock Length Meters"
                                          hide-details="auto"
                                          @change="$emit('update:jobItemTasks', jobItemTasks);"
                                          v-model.number="line.pickLength"></v-text-field>
                        </v-col>
                    </v-row>
                </td>
                <td v-if="showStockSelector" :class="{'full-select-quantity':line.stockStripQuantity >= line.itemQuantity, 'part-select-quantity':line.stockStripQuantity > 0}" class="no-select-quantity">
                    <v-text-field density="compact"
                                  reverse
                                  hide-details="auto"
                                  :disabled="line.quantity == 0"
                                  @change="$emit('update:jobItemTasks', jobItemTasks);"
                                  v-model.number="line.stockStripQuantity"></v-text-field>
                    <v-row>
                        <v-col cols="12"><small v-if="line.length">{{ line.length }}M</small><small v-if="!line.length">No Length</small></v-col>
                    </v-row>
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td><h4>TOTAL ITEMS</h4></td>
                <td class="text-right"><h4>{{ numberWithCommas(totalJobSelectItems,2) }}</h4></td>
                <td v-if="showStockSelector" class="text-right"><h4>{{ numberWithCommas(totalPickedJobSelectItems,2) }}</h4></td>
                <td v-if="showStockSelector" class="text-right"><h4>{{ numberWithCommas(totalStockStripJobSelectItems,2) }}</h4></td>
            </tr>
        </tfoot>
    </v-table>
</template>
<style scoped>
    .no-select-quantity {
        background-color: #F5F5F5 !important;
    }

    .part-select-quantity {
        background-color: #E3F2FD !important;
    }

    .full-select-quantity {
        background-color: #BBDEFB !important;
    }
    .w-25{
        width:25%!important;
    }
</style>
<script>
    import { numberWithCommas } from "../../mixins/numberMixins";
    function initialState() {
        return {
            loading: false
        };
    }
    export default {
        name: "JobTaskItemSelectTable",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            jobItemTasks: Array,
            pickedStock: Boolean
        },
        methods: {
            numberWithCommas
        },
        computed: {
            totalJobSelectItems() {
                let result = 0;
                if (this.jobItemTasks) {
                    this.jobItemTasks.forEach(item => {
                        result += item.quantity;
                    });
                }
                return result;
            },
            totalPickedJobSelectItems() {
                let result = 0;
                if (this.jobItemTasks) {
                    this.jobItemTasks.forEach(item => {
                        result += item.pickedQuantity;
                    });
                }
                return result;
            },
            totalStockStripJobSelectItems() {
                let result = 0;
                if (this.jobItemTasks) {
                    this.jobItemTasks.forEach(item => {
                        result += item.stockStripQuantity;
                    });
                }
                return result;
            },
            showStockSelector() {
                return this.pickedStock === true;
            }
        }
    };
</script>